import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { UTF8ToB64 } from '../utils'

export default {

  data: function () {
    return {
      tenantsList: [],
      tenantName: '',
      leakDaysThreshold: '',
      leakReminderFrequency: '',
      maxNumberOfLeakAlertReminders: '',
      leakRepairedSurvey: '',
      leakActiveNoDiagnoseSurvey: '',
      installSuccessSurvey: '',
      leakActiveSurvey: '',
      leakDaysAllowed: '0',
      surveyAllowed: '0',
      waterUsageAllowed: '0',
      smsAllowed: '0',
      emailAllowed: '0',
      highflowSmsAllowed: '0',
      tenantCode: '',
      monthlyUpdatesAllowed: '0',
      monthlyUpdatesFrequency: '',
      installChasersFrequency: '',
      maxNumberOfInstallChasers: '',
      lostConnectionFrequency: '',
      maxNumberofLostConnectionReminders: '',
      frozenPipeThreshold: '',
      vacantPropertyLeakTest: '0',
      frozenPipe: '0',
      oldTenantName: '',
      oldLeakDaysThreshold: '',
      oldLeakReminderFrequency: '',
      oldMaxNumberOfLeakAlertReminders: '',
      oldLeakActiveSurvey: '',
      oldLeakRepairedSurvey: '',
      oldLeakActiveNoDiagnoseSurvey: '',
      oldInstallSuccessSurvey: '',
      oldSurveyAllowed: '',
      oldWaterUsageAllowed: '',
      oldSmsAllowed: '',
      oldEmailAllowed: '',
      oldLeakDaysAllowed: '',
      oldHighflowSmsAllowed: '',
      oldTenantCode: '',
      oldMonthlyUpdatesAllowed: '',
      oldMonthlyUpdatesFrequency: '',
      oldInstallChasersFrequency: '',
      oldMaxNumberOfInstallChasers: '',
      oldLostConnectionFrequency: '',
      oldMaxNumberofLostConnectionReminders: '',
      oldFrozenPipeThreshold: '',
      oldVacantPropertyLeakTest: '',
      oldFrozenPipe: '',
      tenant_id: '',
      showModal: false,
      fields: {
        id: {
          label: 'ID',
          sortable: false
        },
        name: {
          label: 'Tenant',
          sortable: false,
          class: 'info'
        }
      }
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchTenantsList()
    }
  },
  methods: {
    addTenant () {
      let options = {}
      options.leak_max_reminder = this.leakReminderFrequency
      options.name = this.tenantName
      options.code = this.tenantCode
      options.leak_days_threshold = this.leakDaysThreshold
      options.leak_reminder_fequency = this.leakReminderFrequency
      options.max_number_of_leak_alert_reminders = this.maxNumberOfLeakAlertReminders

      options.install_chasers_frequency = this.installChasersFrequency
      options.install_chasers_max = this.maxNumberOfInstallChasers
      options.lost_connection_frequency = this.lostConnectionFrequency
      options.lost_connection_max = this.maxNumberofLostConnectionReminders
      options.frozen_pipe_threshold = this.frozenPipeThreshold

      options.repair_crm_action_flag = this.leakRepairedSurvey === 'null' ? '' : UTF8ToB64(this.leakRepairedSurvey)
      options.url_waiting_on_pipe = this.installSuccessSurvey === 'null' ? '' : UTF8ToB64(this.installSuccessSurvey)
      options.leak_active_no_diagnose = this.leakActiveNoDiagnoseSurvey === 'null' ? '' : UTF8ToB64(this.leakActiveNoDiagnoseSurvey)
      options.leak_active_diagnose = this.leakActiveSurvey === 'null' ? '' : UTF8ToB64(this.leakActiveSurvey)

      options.surveyAllowed = this.surveyAllowed
      options.water_usageAllowed = this.waterUsageAllowed
      options.smsAllowed = this.smsAllowed
      options.emailAllowed = this.emailAllowed
      options.leak_daysAllowed = this.leakDaysAllowed
      options.highflow_sms_allowed = this.highflowSmsAllowed

      options.monthly_updates_frequency = this.monthlyUpdatesFrequency
      options.monthly_updatesAllowed = this.monthlyUpdatesAllowed
      options.vacant_property_leak_tests = this.vacantPropertyLeakTest
      options.frozen_pipe_feature = this.frozenPipe

      if (this.tenantName.trim() !== '' && Number.isInteger(parseInt(this.leakDaysThreshold)) && Number.isInteger(parseInt(this.leakReminderFrequency)) && (this.maxNumberOfLeakAlertReminders > 0)) {
        this.$store.dispatch(APIEvent.ADD_TENANT, options)
          .then(() => {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Tenant added successfully.')
          })
          .catch(this.handleError)
      } else {
        EventBus.$emit(StatusBarEvent.WARNING,
          'The Tenant can not added. Please fill in all Mandatory Fields.')
      }
    },
    fetchTenantsList () {
      this.tenantsList = this.$store.state.tenantsList
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.currentPage++
      } else {
        this.startOffset -= this.perPage
        this.currentPage--
      }
      this.fetchTenantsList(this.startOffset, this.requestData)
    },
    updateTenant: function () {
      let options = {}
      options.tenant_id = this.tenant_id
      options.name = this.oldTenantName
      options.code = this.oldTenantCode
      options.emailAllowed = this.oldEmailAllowed
      options.smsAllowed = this.oldSmsAllowed
      options.leak_daysAllowed = this.oldLeakDaysAllowed
      options.leak_days_threshold = this.oldLeakDaysThreshold
      options.water_usageAllowed = this.oldWaterUsageAllowed
      options.surveyAllowed = this.oldSurveyAllowed
      options.leak_reminder_fequency = this.oldLeakReminderFrequency
      options.leak_max_reminder = this.oldMaxNumberOfLeakAlertReminders
      options.highflow_sms_allowed = this.oldHighflowSmsAllowed
      options.monthly_updatesAllowed = this.oldMonthlyUpdatesAllowed
      options.monthly_updates_frequency = this.oldMonthlyUpdatesFrequency

      options.install_chasers_frequency = this.oldInstallChasersFrequency
      options.install_chasers_max = this.oldMaxNumberOfInstallChasers
      options.lost_connection_frequency = this.oldLostConnectionFrequency
      options.lost_connection_max = this.oldMaxNumberofLostConnectionReminders
      options.frozen_pipe_threshold = this.oldFrozenPipeThreshold

      options.monthly_updatesAllowed = this.oldMonthlyUpdatesAllowed
      options.vacant_property_leak_tests = this.oldVacantPropertyLeakTest
      options.frozen_pipe_feature = this.oldFrozenPipe

      if (this.oldSurveyAllowed === '1') {
        options.repair_crm_action_flag = this.oldLeakRepairedSurvey === null ? '' : UTF8ToB64(this.oldLeakRepairedSurvey)
        options.url_waiting_on_pipe = this.oldInstallSuccessSurvey === null ? '' : UTF8ToB64(this.oldInstallSuccessSurvey)
        options.leak_active_no_diagnose = this.oldLeakActiveNoDiagnoseSurvey === null ? '' : UTF8ToB64(this.oldLeakActiveNoDiagnoseSurvey)
        options.leak_active_diagnose = this.oldLeakActiveSurvey === null ? '' : UTF8ToB64(this.oldLeakActiveSurvey)
      }

      if (this.oldTenantName.trim() !== '' &&
        Number.isInteger(parseInt(this.oldLeakDaysThreshold)) &&
        Number.isInteger(parseInt(this.oldLeakReminderFrequency)) &&
        options.repair_crm_action_flag !== '' &&
        options.url_waiting_on_pipe !== '' &&
        options.leak_active_no_diagnose !== '' &&
        options.leak_active_diagnose !== ''
      ) {
        this.$store.dispatch(APIEvent.UPDATE_TENANT_INFO, options)
          .then(() => {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Tenant updated successfully.')
          })
          .catch(this.handleError)
      } else {
        EventBus.$emit(StatusBarEvent.WARNING,
          'The Tenant can not be updated. Please fill in all Mandatory Fields.')
      }
    },
    editTenant: function (data) {
      this.$refs.editTenant.show()
      this.tenant_id = data.item.id
      let options = {tenant_id: data.item.id}
      this.$store.dispatch(APIEvent.FETCH_TENANT_INFO, options)
        .then((res) => {
          // console.log(res)
          this.oldTenantName = res.data.name
          this.oldTenantCode = res.data.code
          this.oldLeakDaysThreshold = res.data.leak_days_threshold
          this.oldLeakReminderFrequency = res.data.leak_reminder_fequency
          this.oldMaxNumberOfLeakAlertReminders = res.data.leak_max_reminder
          this.oldLeakRepairedSurvey = res.data.repair_crm_action_flag
          this.oldLeakActiveNoDiagnoseSurvey = res.data.leak_active_no_diagnose
          this.oldInstallSuccessSurvey = res.data.url_waiting_on_pipe
          this.oldLeakActiveSurvey = res.data.leak_active_diagnose
          this.oldMonthlyUpdatesAllowed = res.data.monthly_updatesAllowed
          this.oldMonthlyUpdatesFrequency = res.data.monthly_updates_frequency

          this.oldInstallChasersFrequency = res.data.install_chasers_frequency
          this.oldMaxNumberOfInstallChasers = res.data.install_chasers_max
          this.oldLostConnectionFrequency = res.data.lost_connection_frequency
          this.oldMaxNumberofLostConnectionReminders = res.data.lost_connection_max
          this.oldFrozenPipeThreshold = res.data.frozen_pipe_threshold

          this.oldMonthlyUpdatesAllowed = res.data.monthly_updatesAllowed
          this.oldVacantPropertyLeakTest = res.data.vacant_property_leak_tests
          this.oldFrozenPipe = res.data.frozen_pipe_feature

          // 5 checkboxes
          this.oldSurveyAllowed = res.data.surveyAllowed
          this.oldWaterUsageAllowed = res.data.water_usageAllowed
          this.oldSmsAllowed = res.data.smsAllowed
          this.oldEmailAllowed = res.data.emailAllowed
          this.oldLeakDaysAllowed = res.data.leak_daysAllowed
          this.oldHighflowSmsAllowed = res.data.highflow_sms_allowed
        })
        .catch(this.handleError)
      return this.tenant_id
    }
  }
}
